import styled from 'styled-components'
import { theme } from '../../../../style/theme'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const OrderInfoTabs = styled.div`
	border-radius: 0.75em;
	border: 1px solid ${colorTheme.processingTimeOrderModal.tabs.border};
	display: grid;
	grid-template-columns: 1fr 1fr;
	height: 3em;
	padding: 0 0.32em;
	align-items: center;
`
OrderInfoTabs.displayName = 'OrderInfoTabs'

export const OrderInfoTab = styled.div`
	display: flex;
	height: 2.37em;
	padding: 0 0.63em;
	justify-content: center;
	align-items: center;
	gap: 0.32em;
	transition: all 0.2s;
	cursor: pointer;

	&.active {
		border-radius: 0.63em;
		background: ${colorTheme.processingTimeOrderModal.tabs.active.background};
	}
`
OrderInfoTab.displayName = 'OrderInfoTab'

export const OrderInfoTabText = styled.div`
	color: ${colorTheme.processingTimeOrderModal.tabs.text};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.06em;

	&.active {
		color: ${colorTheme.processingTimeOrderModal.tabs.active.text};
		font-family: ${theme.fontRobotoRegular};
	}
`
OrderInfoTabText.displayName = 'OrderInfoTabText'
